import Vue from 'vue';

export default class Helpers {
  constructor() {
    return;
  }

  

  memberStatusToText(memberStatus) {
    // switch statement on memberStatus
    /*
      0 - AST_DEVICE_UNKNOWN
      1 - AST_DEVICE_NOT_INUSE
      2 - AST_DEVICE_INUSE
      3 - AST_DEVICE_BUSY
      4 - AST_DEVICE_INVALID
      5 - AST_DEVICE_UNAVAILABLE
      6 - AST_DEVICE_RINGING
      7 - AST_DEVICE_RINGINUSE
      8 - AST_DEVICE_ONHOLD
    */
    if (!memberStatus) return 'Unknown';
    memberStatus = parseInt(memberStatus);
    switch(memberStatus) {
      case 0:
        return 'Unknown';
      case 1:
        return 'Not in use';
      case 2:
        return 'In use';
      case 3:
        return 'Busy';
      case 4:
        return 'Invalid';
      case 5:
        return 'Unavailable';
      case 6:
        return 'Ringing';
      case 7:
        return 'Ringing in use';
      case 8:
        return 'On hold';
      default:
        return 'Unknown';
    }
      
      
  }

}

